export default __webpack_public_path__ + "video-bfc29c2.png";